/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import { Button, ToolTip, Icon } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/exportbox/exportbox_styles';



/* ========== ~~~~~~~~~~ EXPORTBOX ~~~~~~~~~~ ========== */
const ExportBox = (props) => {
    const handleExportClick = () => {
        props.handleExport(props.value)
    };

    return (
        <div className={`exportbox ${props.classes.exportbox}`}>
            <img className={'exportboximg'} src={`${url.image}/illustrations/${props.image}`}/>
            <div className={'exportdescription'}>
                <span className={'title'}>
                    {props.title}
                    <span className={'titletip'}>
                        <ToolTip children={<Icon name={'question-circle'}/>} position={'right'} content={props.tipcontent} />
                    </span>
                </span>
                <span className={'subdescription'}>
                    {props.subdescription}
                </span>
            </div>
            <div className={'ctabutton'}>
                <Button klass={'exportbutton'}
                    processing={props.processing}
                    disabled={!!props.selected}
                    variant={'primary'}
                    text={props.buttontext}
                    action={handleExportClick}
                    type={'action'}
                />
            </div>
        </div>
    );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ExportBox);
